import { pick } from 'lodash';

export const name = 'Слых: Запіс за дыктоўкай';
export const nameShort = 'Запіс за дыктоўкай';
export const bgInTable = '#ecc846';

export const fields = [
  {
    name: 'correctAnswers',
    default: [],
    label: 'Правільныя адказы',
    component: 'ListNewValues',
  },
  {
    name: 'afterTaskExplanation',
    default: '',
    label: 'Тлумачэнне задання',
    component: 'Textarea',
  },
  {
    name: 'textContent',
    default: '',
    label: 'Змест задання',
    component: 'Input',
  },
  {
    name: 'audio',
    default: '',
    label: 'Аўдыёзапісы',
    component: 'AudioInput',
  },
];

export const dataToSend = form => {
  return {
    type: 'dictation',
    name: form.name,
    tip: form.tip,
    status: form.status,
    additionalData: {
      afterTaskExplanation: form.afterTaskExplanation,
      textContent: form.textContent,
    },
    correctAnswers: form.correctAnswers,
    audio: form.audio,
  };
};

export const parseData = data => {
  const dataFast = pick(data, ['name', 'status', 'tip', 'audio', 'correctAnswers']);
  const { afterTaskExplanation, textContent } = data.additionalData;
  return {
    ...dataFast,
    afterTaskExplanation,
    textContent,
  };
};
